import { Link } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/episodes", label: "全部剧集" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于本站" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 md:mt-24 bg-background-900 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:max-w-md">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-background-950 flex items-center justify-center font-heading text-base font-semibold">
                4
              </span>
              <h3 className="font-heading text-lg tracking-wide text-foreground-950">
                朋友的妈妈4影视站
              </h3>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-500">
              专注「朋友的妈妈4」单部剧集的专题影视站，提供全 16 集目录、分集剧情介绍与演示播放区，
              不收录其他影视内容，保证浏览聚焦、信息精准。
            </p>
            <p className="mt-4 text-xs leading-6 text-foreground-600">
              本站为内容演示站点，视频播放区域为前端模拟界面，不提供真实播放接口。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="text-xs tracking-[0.2em] text-foreground-500 uppercase mb-4">
                站点导航
              </h4>
              <ul className="space-y-3">
                {navItems.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs tracking-[0.2em] text-foreground-500 uppercase mb-4">
                剧集入口
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/detail/ep-01"
                    className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    第1集 · 搬来的邻居
                  </Link>
                </li>
                <li>
                  <Link
                    to="/detail/ep-09"
                    className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    第9集 · 画室
                  </Link>
                </li>
                <li>
                  <Link
                    to="/detail/ep-16"
                    className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    第16集 · 窗外的树
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-xs tracking-[0.2em] text-foreground-500 uppercase mb-4">
                剧集信息
              </h4>
              <ul className="space-y-3 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <i className="ri-film-line text-accent-500" />
                  全 16 集 · 已完结
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-calendar-line text-accent-500" />
                  2026.06.12 首播
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-accent-500" />
                  单集约 42 分钟
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 朋友的妈妈4影视站 · 本站内容仅用于页面演示，不存储、不传播任何视频文件。
          </p>
          <p className="text-xs text-foreground-600">
            版权归原制作方所有 · 如有侵权请联系删除
          </p>
        </div>
      </div>
    </footer>
  );
}